
function findSplits({ rowsIndices, endOfGridIndices, splitIndices, numberOfLines, getPageSplits }: { rowsIndices: number[], endOfGridIndices: number[], splitIndices: number[], numberOfLines: number, getPageSplits: boolean }) {
    let iAmInAGrid = false
    const gridSplits: number[] = []

    for (let i = 0; i <= numberOfLines; i++) {

        if (rowsIndices.find(r => r === i) !== undefined) {
            iAmInAGrid = true
        }

        if (endOfGridIndices.find(e => e === i) !== undefined) {
            iAmInAGrid = false
        }

        if (splitIndices.find(s => s == i) !== undefined && iAmInAGrid) gridSplits.push(i)
    }

    if (getPageSplits) {
        return splitIndices.length === 0 ? splitIndices : splitIndices.filter(splitIdx => !gridSplits.includes(splitIdx))
    } else {
        return gridSplits
    }
}



export default findSplits